<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { ReportEditorViewModel } from "@Reports/Reports/Components/ReportEditor";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class ReportEditor extends Vue
    {
        get vm(): ReportEditorViewModel { return this.$props.viewModel as ReportEditorViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get isSaving() { return this.vm.isSaving; }
        get d() { return this.vm.data; }
        get nameError() { return this.vm.reportNameError; }

        onFormSubmit()
        {
            this.vm.clearValidationErrors();
            this.vm.isSaving = true;

            this.$emit('update-report', this.vm.data);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Edit report</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="report-editor-form" @submit.prevent="onFormSubmit">
                            <div class="form-group">
                                <label>Report name:</label>
                                <input type="text" v-model.trim="d.Name" class="form-control" required maxlength="100" minlength="2">
                                <small class="text-danger">{{nameError}}</small>
                            </div>
                            <div class="form-group">
                                <label>Description (optional):</label>
                                <textarea v-model.trim="d.Description" class="form-control" rows="5" maxlength="250"></textarea>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer">

                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="report-editor-form" :disabled="isSaving" class="btn btn-primary">
                            <span v-if="isSaving"><i class="fa fa-spinner fa-spin"></i> Please wait...</span>
                            <span v-if="!isSaving">Update</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>